module.exports = __webpack_public_path__ + "static/img/zhongTu.e1362723.png";